import { namespacedConsts, } from 'utils/object';
import { dispatchAction, } from 'application/AppDispatcher';

const CONSTS = namespacedConsts({
  MODAL: {
    ACTIONS: {
      CLOSE: true,
    },
  },
});

let modalActions = {

  TYPES: CONSTS.MODAL.ACTIONS,

  closeModal: () => {
    dispatchAction.view({
      type: modalActions.TYPES.CLOSE,
    });
  },

};

export default modalActions;


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/modalActions.js